import {ThemeInterface} from '@eCommerce/frontend-legacy-shared-library-native';
import {useToken} from 'native-base';

export const useFontFamily = (
  type: keyof ThemeInterface['fonts'],
  fontWeight = 400,
  modifier: 'normal' | 'italic' = 'normal'
) => {
  const fontFamilyCategory = useToken('fonts', type);
  return useToken(
    'fontConfig',
    `${fontFamilyCategory}.${fontWeight}.${modifier}`
  );
};
